export default __webpack_public_path__ + "static/media/copy.1df680db.svg";